// https://confluence.expedia.biz/pages/viewpage.action?pageId=1615089819#ClickstreamInteractionEventSchemasHome/Landing-SchemaTables

const searchSubmitted = {
  experience: {
    page_name: "Home",
  },
  event: {
    event_version: "1.0.0",
    event_name: "search.submitted",
    event_type: "Interaction",
    event_category: "search_query_module",
    clickstream_trace_id: "a14dfd28-61bd-437b-985f-26497444f5ca",
  },
};

export const clickstreamSchema = {
  searchSubmitted,
};
